export enum States{
    Acre = 'AC',
    Alagoas = 'AL',
    Amazonas = 'AM',
    Amapa = 'AP',
    Bahia = 'BA',
    Ceara = 'CE',
    DistritoFederal = 'DF',
    EspiritoSanto = 'ES',
    Goias = 'GO',
    Maranhao = 'MA',
    MinasGerais = 'MG',
    MatoGrossoSul = 'MS',
    MatoGrosso = 'MT',
    Para = 'PA',
    Paraiba = 'PB',
    Pernambuco = 'PE',
    Piaui = 'PI',
    Parana = 'PR',
    RioDeJaneiro = 'RJ',
    RioGrandeNorte = 'RN',
    Rondonia = 'RO',
    Roraima = 'RR',
    RioGrandeSul = 'RS',
    SantaCatarina = 'SC',
    Sergipe = 'SE',
    SaoPaulo = 'SP',
    Tocantins = 'TO'
}